import { Injectable, OnInit } from "@angular/core";
import * as _ from "lodash";
import { FormGroup, FormControl } from "@angular/forms";
import { DatePipe, PlatformLocation } from "@angular/common";
import { ApiService } from "./api.service";
import { catchError, of, throwError } from "rxjs";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root",
})
export class HelperService implements OnInit {
  public loggedUser: any;
  public apiBaseUrl: any;

  constructor(public loc: PlatformLocation, public datePipe: DatePipe,private apiServicce:ApiService,private http:HttpClient) {
    this.apiBaseUrl = environment.SERVER_ROOT_URL
  }

  public ngOnInit() {}

  imagetoDataURL(url: any) {
    return fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
  }

  isEmpty(data: string) {
    if (data === "") return true;
    return false;
  }

  /**
   *
   * This method will dynamically collect the all the form fields and apply the validation rules
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  getDataFromRow(
    row: any,
    col: any,
    type: any,
    prefix?: any,
    suffix?: any
  ): any {
    if (!row) return "";
    if (col instanceof Array) {
      let result = "";
      for (let idx = 0; idx < col.length; idx++) {
        result += this.getDataFromRow(row, col[idx], type, prefix, suffix);
      }
      return result;
    } else {
      if (col instanceof Object) {
        return this.getDataFromRow(row, col.name, type, col.prefix, col.suffix);
      } else {
        var dot = col.indexOf(".");
        if (dot > 0) {
          if (row[col.substr(0, dot)])
            return this.getDataFromRow(
              row[col.substr(0, dot)],
              col.substr(dot + 1),
              type,
              prefix,
              suffix
            );
        }
        if (row) {
          let val = this.formatData(row[col], type);
          return val != "" ? (prefix || "") + val + (suffix || "") : "";
        }
      }
    }
    return "";
  }

  formatData(data: any, type: any) {
    if (!data) return "";
    if (type == "date") {
      return this.showDate(data);
    } else if (type == "time") {
      return this.showTime(data);
    } else if (type == "dateTime") {
      return this.showDateTime(data);
    } else if (type == "duration") {
      return this.convertMinsToHrsMins(data);
    }
    return data;
  }

  getDataByPath(data: any, path: string) {
    if (!path) return data; // if path is undefined or empty return data
    if (path.startsWith("'")) return path.replace(/'/g, "");
    var paths = path.split(".");
    for (var p in paths) {
      if (!paths[p]) continue;
      data = data[paths[p]]; // new data is subdata of data
      if (!data) return data;
    }
    return data;
  }

  newGetDataByPath(data: any, path: String) {
    if (!path) return data; // if path is undefined or empty return data
    if (path.startsWith("'")) return path.replace(/'/g, "");
    var paths = path.split(".");
    let filter = "";

    for (var p in paths) {
      if (!paths[p]) continue;
      if (data[paths[p]]) {
        data = data[paths[p]]; // new data is subdata of data
      } else {
        if (data.length) {
          data.forEach((res: any) => {
            filter += res[paths[p]] + ",";
          });
          data = filter.slice(0, filter.lastIndexOf(","));
        }
      }
      if (!data) return data;
    }
    return data;
  }

  processText(exp: any, data: any) {
    if (data !== null) {
      exp = exp.replace(
        /{{(\w+)}}/g, // this is the regex to replace %variable%
        (match: any, field: any) => {
          return this.getDataByPath(data, field) || "";
        }
      );
      return exp.trim();
    }
  }

  buildOptions(res: any, to: any) {
    var data = res.data ? res.data : res;
    if (to.labelPropTemplate) {
      data.map((e: any) => {
        e[to.labelProp] = this.processText(to.labelPropTemplate, e);
      });
    }
    data = _.sortBy(data, to.labelProp);
    to.options = data;
  }

  convertMinsToHrsMins(minutes: any) {
    let hours, mins;
    var h = Math.floor(minutes / 60);
    var m = Math.round(minutes % 60);
    hours = h < 10 ? "0" + h : h;
    mins = m < 10 ? "0" + m : m;
    return hours + ":" + mins;
  }

  showDate(dt: any) {
    if (!dt) return "";
    try {
      return this.datePipe.transform(dt, "dd-MMM-yy");
    } catch (e) {
      return "";
    }
  }

  showDateTime(dt: any) {
    if (!dt) return "";
    try {
      return this.datePipe.transform(dt, "dd-MM-yy hh:mm a");
    } catch (e) {
      return "";
    }
  }

  showFullDate(dt: any) {
    if (!dt) return "";
    try {
      return this.datePipe.transform(dt, "EEE, MMM d, y");
    } catch (e) {
      return "";
    }
  }

  showFullDateTime(dt: any) {
    if (!dt) return "";
    try {
      return this.datePipe.transform(dt, "EEE, MMM d, y, hh:mm a");
    } catch (e) {
      return "";
    }
  }

  showTime(dt: any) {
    if (!dt) return "";
    try {
      return this.datePipe.transform(dt, "hh:mm a");
    } catch (e) {
      return "";
    }
  }

  initCaps(str: string): string {
    str = str.toLowerCase().replace(/_/g, " ");
    return str.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
      return match.toUpperCase();
    });
  }

  getHelpInfoPath(payload:any) {
    return this.apiServicce.post("api/help/get-help-doc",payload);
  }

  getSelectedFileUrl(payload:any) {
    return this.http.post(`${this.apiBaseUrl}/hr-api/trainings/get-training-url`, payload, { responseType: 'text' })
    .pipe(
      // Handle response as text
      catchError(this.handleError),
      // Attempt to parse the response as JSON if it's a text response
      catchError(response => {
        try {
          return of(JSON.parse(response));
        } catch (e) {
          return throwError(() => new Error('Invalid JSON or error response: ' + response));
        }
      })
    );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Server error code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => new Error(errorMessage));
  }
}
